import logo from "./logo.svg";
import "./App.css";
import { Outlet } from "react-router-dom";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { PrimeReactProvider } from "primereact/api";
import { ConfigProvider } from "antd";

function App() {
  console.log("app");
  return (
    // <ReportContext>
    <PrimeReactProvider>
      <ConfigProvider
        theme={{
          components: {
            Menu: {
              // itemSelectedBg: "#C0E5C8",
              // itemSelectedColor: "#008181",
              itemBg: 'white',
              subMenuItemBg: 'white',
              subMenuItemBorderRadius: 0,
              popupBg: '#008181',
              itemColor: '#008181',
              itemSelectedBg: '#008181',
              itemBorderRadius: 0,
              itemMarginInline: 15,
              itemHoverBg: '#008181',
              itemHoverColor: 'white',
              itemSelectedColor: '#ffcd04',
              optionSelectedColor: '#003049',
              
              itemDisabledColor: '#CCAD8F',
              subMenuItemSelectedColor: '#005252ff'
            },
            Radio: {
              buttonSolidCheckedBg: "#008181",
              colorPrimary: "#008181",

            },
            Spin: {
              colorPrimary: "#008181",
            },
            Tabs: {
              inkBarColor: "#008181",
              itemColor: "#008181",
              itemSelectedColor: "#008181",
              itemHoverColor: "#008181",
            },
            Switch: {
              colorPrimary: "#008181",
              colorPrimaryHover: "#008181CC",
            },
            Transfer: {
              colorBgContainer: "#00818122",
              controlItemBgActive: "#00818111",
            },
            Button: {
              colorPrimary: "#008181",
              colorPrimaryHover: "#008181CC",
              colorPrimaryActive: "#008181BB",
            },
            Checkbox: {
              colorPrimary: "#008181",
            },
          },
        }}>
        <Outlet />
      </ConfigProvider>
    </PrimeReactProvider>
    // </ReportContext>
  );
}

export default App;
